import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import EnquiryForm from "./EnquiryForm";
import { EnquiryCtx } from "./enquiryContext";
import "./site.css";
import { useVisitTracker } from "./visitTracker";
import api from "../../lib/api";
import { applySiteSettings } from "./siteData";

let settingsLoaded = false;


function ScrollManager() {
  const { pathname, hash } = useLocation();
  useVisitTracker(pathname);
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 60);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function SiteLayout() {
  const [modal, setModal] = useState(null);
  const open = useCallback((opts = {}) => setModal(opts), []);
  const isCareer = modal?.kind === "application";
  const [ready, setReady] = useState(settingsLoaded);
  useEffect(() => {
    if (settingsLoaded) return;
    const done = () => { settingsLoaded = true; setReady(true); };
    const t = setTimeout(done, 2500);
    api.get("/public/site-settings").then((r) => applySiteSettings(r.data)).catch(() => {}).finally(() => { clearTimeout(t); done(); });
  }, []);
  if (!ready) return <div className="site min-h-screen bg-[#0C1726]" data-testid="public-site-loading" />;

  return (
    <EnquiryCtx.Provider value={open}>
      <div className="site min-h-screen flex flex-col" data-testid="public-site">
        <ScrollManager />
        <SiteHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <SiteFooter />
        <Dialog open={!!modal} onOpenChange={(v) => !v && setModal(null)}>
          <DialogContent className="site max-w-2xl max-h-[92vh] overflow-y-auto rounded-none border-t-4 border-t-[#C4A66A]" data-testid="enquiry-modal">
            <DialogHeader>
              <div className="site-eyebrow">{isCareer ? "Apply" : "Enquire"}</div>
              <DialogTitle className="font-serif text-3xl text-[#14263D]">
                {isCareer ? (modal?.position ? `Apply — ${modal.position}` : "Send us your profile") : "Tell us about your mandate"}
              </DialogTitle>
              <DialogDescription>
                {isCareer ? "Attach your CV. Our HR team reviews every application." : "A partner will respond within one business day."}
              </DialogDescription>
            </DialogHeader>
            {modal && <EnquiryForm {...modal} compact />}
          </DialogContent>
        </Dialog>
      </div>
    </EnquiryCtx.Provider>
  );
}
